import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { LayoutType } from 'global/types/enums'
import { useLazyGetReferralRewardDetailQuery } from 'store/referral-code'
import { DataHandler } from 'shared/components/data-handler'
import { Layout } from 'shared/components/layout'
import { Card } from 'shared/components/card'
import { StatusBadge } from 'shared/components/status-badge'
import { formatDateTime } from 'shared/services/utils'
import { L10N } from 'global/localization'

export const ReferralRewardDetail = () => {
  const { id } = useParams()

  const [getDetail, detailResult] = useLazyGetReferralRewardDetailQuery()

  useEffect(() => {
    if (!id) return
    getDetail(id)
  }, [id])

  const data = detailResult.data

  return (
    <Layout title='Referral Reward Detail' type={LayoutType.Header}>
      <DataHandler isLoading={detailResult.isLoading} error={detailResult.error}>
        {data && (
          <>
            <Card bannerImage={data.carImageUrl ?? '/unknown-car.png'}>
              <h2 className='font-heading font-medium text-xl mb-3'>{data.carModelName}</h2>

              <div className='flex flex-row'>
                <div className='flex-1'>
                  <div className='text-neutral text-xs'>{L10N.LABEL.REGISTERED_OWNER}</div>
                  <div className='font-heading text-sm'>{data.ownerName}</div>
                </div>
                <div className='flex-1'>
                  <div className='text-neutral text-xs'>{L10N.LABEL.VIN}</div>
                  <div className='font-heading text-sm'>{data.vin}</div>
                </div>
              </div>
            </Card>

            <h2 className='font-heading font-medium mb-4'>{L10N.LABEL.PAYMENT_INFORMATION}</h2>

            <Card>
              <div className='flex flex-row items-center justify-between gap-3 mb-3'>
                <div className='text-neutral text-sm'>{L10N.LABEL.STATUS}</div>
                <StatusBadge label={data.status} value={data.status} />
              </div>

              <div className='flex flex-row items-center justify-between gap-3 mb-3'>
                <div className='text-neutral text-sm'>Referral Claim Date</div>
                <div className='font-medium text-sm text-right'>
                  {formatDateTime(data.referralClaimDate)}
                </div>
              </div>

              <div className='flex flex-row items-center justify-between gap-3'>
                <div className='text-neutral text-sm'>Reward Amount</div>
                <div className='font-medium text-sm text-right'>{data.rewardAmount}</div>
              </div>
            </Card>
          </>
        )}
      </DataHandler>
    </Layout>
  )
}
